import { useMemo } from 'react';
import { useAppContext } from '../../../../../Services/AppContext';
import { MetaKey } from '../../../../Meta/Enums/MetaKey.enum';
import useWorkplaceMeta from '../../../../Workplace/Hooks/useWorkplaceMeta';
import useMeta from '../../../../Meta/Hooks/useMeta';

export default function useIdentificationCode() {
	const { workplaceId } = useAppContext();
	const { workplaceMeta, reFetchWorkplaceMeta, isLoadingWorkplaceMeta } =
		useWorkplaceMeta({
			workplaceId,
		});
	const { createWorkplaceMeta } = useMeta();

	const lastIdentificationCode: number | null = useMemo(() => {
		if (isLoadingWorkplaceMeta) {
			return null;
		}
		const metaValue = workplaceMeta[MetaKey.LAST_IDENTIFICATION_CODE];
		return metaValue ?? 0;
	}, [workplaceMeta, isLoadingWorkplaceMeta]);

	const nextIdentificationCode = useMemo(() => {
		if (lastIdentificationCode === null) {
			return null;
		}
		const nextCode = lastIdentificationCode + 1;
		const formattedCode = nextCode.toString().padStart(3, '0');
		return `S${formattedCode}`;
	}, [lastIdentificationCode]);

	const updateLastIdentificationCode = async () => {
		if (!lastIdentificationCode) {
			return;
		}
		const result = await createWorkplaceMeta({
			workplaceId,
			meta: {
				key: MetaKey.LAST_IDENTIFICATION_CODE,
				value: lastIdentificationCode + 1,
			},
		});
		if (result.status === 200) {
			reFetchWorkplaceMeta();
		}
	};

	return {
		nextIdentificationCode,
		updateLastIdentificationCode,
	};
}
